/**
 * Маппинг разделов WMS → slug-и статей базы знаний (кнопка «?» на экране, HelpButton).
 * title — как экран называется в меню (navConfig.js); slug должен быть в
 * backend/app/kb/*.md. На один экран — статьи для склада И для клиента: сервер сам
 * отдаёт каждому только статьи его аудитории (api/knowledge.py, 05.10).
 */
const helpMapping = {
  '/work': { title: 'Моя смена', slugs: ['sklad-pervaya-smena', 'skan-ne-prohodit'] },
  '/tasks': { title: 'Задачи', slugs: ['zadachi-sklada', 'klient-zadachi-skladu'] },
  '/board': { title: 'Склад сейчас', slugs: ['doska-sklad-seychas'] },
  '/dashboard': { title: 'Главная', slugs: ['klient-pervye-shagi', 'doska-sklad-seychas'] },
  '/shift': { title: 'Кто на смене', slugs: ['ruk-kto-na-smene', 'ruk-personal-i-dostupy'] },
  '/temp-workers': { title: 'Подработчики', slugs: ['ruk-podrabotchiki'] },
  '/warehouse-activity': { title: 'Работа склада', slugs: ['ruk-rabota-sklada'] },

  '/arrivals': { title: 'Приёмки', slugs: ['klient-priyomka', 'sklad-priyomka', 'priyomka-pereschet', 'tovar-ne-nahoditsya-pri-skane'] },
  '/pickups': { title: 'Забор', slugs: ['klient-zabor'] },
  '/pvz-returns': { title: 'Возвраты ПВЗ', slugs: ['klient-vozvraty-pvz', 'sklad-vozvraty-pvz'] },
  '/box-placement': { title: 'Размещение коробов', slugs: ['sklad-razmeshchenie-korobov', 'gde-lezhit-tovar'] },
  '/placement': { title: 'Размещение штучно', slugs: ['sklad-razmeshchenie-shtuchno', 'gde-lezhit-tovar'] },
  '/where-is': { title: 'Где лежит товар', slugs: ['gde-lezhit-tovar'] },

  '/products': { title: 'Каталог', slugs: ['klient-katalog-tovarov', 'ostatki-dlya-sklada', 'tovar-ne-nahoditsya-pri-skane'] },
  '/warehouse': { title: 'Остатки', slugs: ['klient-ostatki', 'ostatki-dlya-sklada', 'ne-hvataet-ostatka'] },
  '/stock-log': { title: 'Движение', slugs: ['ostatki-dlya-sklada'] },
  '/product-management': { title: 'Загрузка Excel', slugs: ['klient-katalog-tovarov'] },
  '/barcodes': { title: 'Баркоды в Excel', slugs: ['klient-katalog-tovarov'] },
  '/storage': { title: 'Ячейки', slugs: ['konstruktor-sklada', 'gde-lezhit-tovar'] },
  '/warehouse-builder': { title: 'Конструктор склада', slugs: ['konstruktor-sklada'] },
  '/defects': { title: 'Брак / Пересорт', slugs: ['klient-brak-peresort', 'sklad-brak-i-peresort'] },
  '/client-brak': { title: 'В ячейках брака', slugs: ['sklad-brak-i-peresort'] },
  '/pallet-audit-confirm': { title: 'Расхождения', slugs: ['sverki-yacheek-i-palet', 'ostatki-dlya-sklada'] },
  '/cell-audit': { title: 'Ячейки и палеты', slugs: ['sverki-yacheek-i-palet'] },

  '/processing': { title: 'Отгрузки', slugs: ['klient-otgruzka', 'sklad-sborka-otgruzki', 'skan-ne-prohodit', 'vykladka-fbs-fp'] },
  '/orders/create': { title: 'Создать отгрузку', slugs: ['klient-otgruzka', 'ne-hvataet-ostatka', 'vykladka-fbs-fp'] },
  '/picking': { title: 'Лист подбора', slugs: ['sklad-sborka-otgruzki'] },
  '/scanning': { title: 'Сканирование', slugs: ['sklad-sborka-otgruzki', 'skan-ne-prohodit'] },
  '/trucks': { title: 'Рейсы', slugs: ['ruk-reysy-i-sroki'] },

  '/marking': { title: 'Коды ЧЗ', slugs: ['kody-chz-zagruzka'] },
  '/reprint': { title: 'Повторная печать', slugs: ['pechat-agent-i-printery'] },

  '/fbs-hub': { title: 'Центр ФБС', slugs: ['sklad-sborka-fbs', 'fbs-net-zakazov-ili-vitrina-nol'] },
  '/fbs': { title: 'Заказы ФБС', slugs: ['klient-zakazy-fbs', 'sklad-sborka-fbs', 'fbs-net-zakazov-ili-vitrina-nol'] },
  '/ozon-fbs': { title: 'Ozon ФБС', slugs: ['ruk-ozon-fbs'] },
  '/fbs-dashboard': { title: 'Сроки и машины', slugs: ['ruk-reysy-i-sroki', 'klient-zakazy-fbs'] },
  '/fbs-unaccepted': { title: 'Не принято WB', slugs: ['klient-zakazy-fbs'] },
  '/fbs-assembly': { title: 'Сборка ФБС', slugs: ['sklad-sborka-fbs', 'pechat-agent-i-printery'] },
  '/fbs-zone-intake': { title: 'Пополнение зоны', slugs: ['sklad-popolnenie-zony-fbs', 'skan-ne-prohodit'] },
  '/fbs-move': { title: 'Переставить', slugs: ['sklad-rabota-v-zone-fbs'] },
  '/box-recount': { title: 'Пересчитать короб', slugs: ['sklad-rabota-v-zone-fbs'] },
  '/fbs-tails': { title: 'Хвосты', slugs: ['sklad-rabota-v-zone-fbs', 'fbs-net-zakazov-ili-vitrina-nol'] },
  '/fbs-return-buffer': { title: 'Вернуть на Основной', slugs: ['sklad-rabota-v-zone-fbs'] },
  '/fbs-zone-control': { title: 'Контроль зоны', slugs: ['sklad-rabota-v-zone-fbs', 'pereuchet-zony-fbs'] },
  '/fbs-recount': { title: 'Переучёт', slugs: ['pereuchet-zony-fbs'] },

  '/companies': { title: 'Клиенты', slugs: ['ruk-klienty', 'klient-polzovateli-i-rekvizity'] },
  '/admin/finance': { title: 'Финансы клиентов', slugs: ['ruk-finansy-klientov'] },
  '/finance': { title: 'Начисления', slugs: ['klient-finansy'] },
  '/storage-billing': { title: 'Хранение', slugs: ['klient-hranenie'] },
  '/services': { title: 'Услуги', slugs: ['ruk-prais-i-tz'] },
  '/product-services-tz': { title: 'ТЗ товаров', slugs: ['klient-tz-tovarov', 'ruk-prais-i-tz'] },
  '/my-consumables': { title: 'Расходники', slugs: ['klient-raskhodniki'] },

  '/marketplace': { title: 'Маркетплейсы', slugs: ['podklyuchenie-wb', 'podklyuchenie-ozon-ym-lamoda', 'ruk-nastroyki-fbs'] },
  '/shipping-warehouses': { title: 'Склады отгрузки', slugs: ['ruk-sklady-otgruzki'] },
  '/label-templates': { title: 'Шаблоны этикеток', slugs: ['shablony-etiketok', 'pechat-agent-i-printery'] },
  '/printers': { title: 'Принтеры', slugs: ['ruk-printery-i-agent', 'pechat-agent-i-printery'] },
  '/tsd': { title: 'Терминалы (ТСД)', slugs: ['tsd-terminal'] },
  '/users': { title: 'Сотрудники', slugs: ['ruk-personal-i-dostupy'] },
  '/staff-access': { title: 'Персонал и доступы', slugs: ['ruk-personal-i-dostupy'] },
  '/admin/notifications': { title: 'Уведомления и бот', slugs: ['ruk-uvedomleniya-i-bot'] },
  '/integrations/api': { title: 'API', slugs: ['api-dlya-klienta'] },
  '/start': { title: 'С чего начать', slugs: ['oblako-nachalo-raboty'] },
  '/modules': { title: 'Каталог модулей', slugs: ['oblako-nachalo-raboty'] },
  '/subscription': { title: 'Тариф и оплата', slugs: ['oblako-nachalo-raboty'] },
  '/settings/brand': { title: 'Бренд и домен', slugs: ['oblako-nachalo-raboty'] },
};

export default helpMapping;
